export default "__VITE_ASSET__CNeVZQWP__"